// HomePresentacion.js
import React, { useMemo, useRef, useState } from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'react-toastify';
import { Canvg } from 'canvg';

// Íconos:
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ReplyIcon from "@mui/icons-material/Reply";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from '@mui/icons-material/Info';
import DownloadIcon from '@mui/icons-material/Download';

// Imágenes
import fondo_intro_jhimbo from "../../images/fondo_intro_jhimbo.png";
import jhimbo_intro_1 from "../../images/jhimbo_intro_1.png";
import jhimbo_intro_2 from "../../images/jhimbo_intro_2.png";
import jhimbo_intro_3 from "../../images/jhimbo_intro_3.png";

import { ModalForAll } from "../global/ModalForAll";
import LogoHosmingSVG from "../../svg/LogoHosmingSVG";
import { returnFullURL } from "../../utils/goblaFunctions";

const API_URL = process.env.REACT_APP_API_URL;

const HomePresentacion = ({ liked, handleLike, isFollowed, handleClickFollow, infoCompany, current_nit, theme }) => {

  const [modalShare, setModalShare] = useState(false);

  const view1 = infoCompany?.view1 ?? {};

  const {
    profile: profileUrl = null,
    cover_url: coverUrl = null,
    name: companyName = 'Cargando nombre...'
  } = infoCompany ?? {};

  // Separamos la primera frase destacada
  const { firstSpan, restOfText } = useMemo(() => {
    if (!view1.text) return { firstSpan: "", restOfText: "" };
    const [first, ...rest] = view1.text.split(".");
    return {
      firstSpan: first.trim(),
      restOfText: rest.join(".").trim(),
    };
  }, [view1.text]);

  const info_company = (
    <>
      <div className="actions-company">
        <span className="text-size text-bold">0</span>
        <span className="text-size">Estrellas</span>
      </div>

      <div className="actions-company">
        <span className="text-size text-bold">0</span>
        <span className="text-size">Seguidores</span>
      </div>

      <div className="actions-company">
        <span className="text-size text-bold">0</span>
        <span className="text-size" style={{ whiteSpace: 'nowrap' }}>Me gusta</span>
      </div>

      <div className="actions-company">
        <span className="text-size text-bold">0</span>
        <span className="text-size">Visitas</span>
      </div>

      <div className="actions-company">
        <span className="text-size text-bold">0</span>
        <span className="text-size">Compartidos</span>
      </div>
    </>
  );

  const link_share = String(window.location.protocol) + '//' + String(window.location.hostname) + '/company/products?search=' + current_nit;


  function copyLinkShare() {
    return new Promise((resolve, reject) => {
      if (!navigator.clipboard) {
        reject(new Error('La API del portapapeles no está disponible'));
        return;
      }
      // Intentar copiar el texto
      navigator.clipboard.writeText(link_share ?? "No se pudo copiar...")
        .then(() => {
          resolve();
          toast.success("Copiado exitosamente", {
            position: 'top-center',
            closeButton: false,
            autoClose: 1500,
            hideProgressBar: false
          });
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  const contenedorRef = useRef(null);

  const handleDownloadSVG = async () => {
    if (!contenedorRef.current) return;

    // Obtener los SVGs dentro del contenedor
    const svg = contenedorRef.current.querySelectorAll('svg');
    if (!svg) return;

    // Clonar los SVGs
    const svgClone = svg[0].cloneNode(true);
    const svgClone2 = svg[1].cloneNode(true);
    const svgClone3 = svg[2]?.cloneNode(true) ?? null;

    // Ajustar tamaño principal
    svgClone.style.margin = '30px';
    svgClone.style.width = '900px';
    svgClone.style.height = '900px';

    // Crear <defs> con gradiente
    const xmlns = "http://www.w3.org/2000/svg";
    const defs = document.createElementNS(xmlns, "defs");
    const linearGradient = document.createElementNS(xmlns, "linearGradient");
    linearGradient.setAttribute("id", "");
    linearGradient.setAttribute("x1", "0%");
    linearGradient.setAttribute("y1", "0%");
    linearGradient.setAttribute("x2", "100%");
    linearGradient.setAttribute("y2", "100%");

    const stop1 = document.createElementNS(xmlns, "stop");
    stop1.setAttribute("offset", "0%");
    stop1.setAttribute("stop-color", "red");

    const stop2 = document.createElementNS(xmlns, "stop");
    stop2.setAttribute("offset", "100%");
    stop2.setAttribute("stop-color", "black");

    linearGradient.appendChild(stop1);
    linearGradient.appendChild(stop2);
    defs.appendChild(linearGradient);

    // Insertar defs al principio del SVG principal
    svgClone.insertBefore(defs, svgClone.firstChild);

    // Escalar y posicionar los SVGs secundarios
    if (svgClone3) {
      svgClone3.style = 'none';
      svgClone3.setAttribute("width", "40%");
      svgClone3.setAttribute("height", "40%");
      svgClone3.setAttribute("x", "10");
      svgClone3.setAttribute("y", "11");
      svgClone2.setAttribute("transform", "scale(1)");
      svgClone.appendChild(svgClone3); // Primero svgClone3 (atrás)
    }

    svgClone2.style = 'none';
    svgClone2.setAttribute("width", "40%");
    svgClone2.setAttribute("height", "40%");
    svgClone2.setAttribute("x", "10");
    svgClone2.setAttribute("y", "11");
    svgClone.appendChild(svgClone2); // Luego svgClone2 (encima)

    // Exportar
    const svgData = new XMLSerializer().serializeToString(svgClone);

    const canvas = document.createElement('canvas');
    canvas.width = 1500;
    canvas.height = 1500;
    const ctx = canvas.getContext('2d');

    const v = await Canvg.from(ctx, svgData);
    await v.render();

    const pngUrl = canvas.toDataURL('image/png');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'qrcode.png';
    downloadLink.click();
  };

  const parseTextWithBlue = (text) => {
    // Separa el texto por segmentos que coincidan con: *contenido*
    if (!text) return;
    const regex = /(\*[^*]+\*)/g;
    const parts = text.split(regex);

    return parts.map((part, index) => {
      // Si el fragmento inicia y termina con '*'
      if (part.match(/\*[^*]+\*/)) {
        // Quita los asteriscos
        const clean = part.replace(/\*/g, "");
        return (
          <span key={index} style={{ color: "var(--theme-visit)" }}>
            {clean}
          </span>
        );
      }
      // Fragmento normal
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <>
      <div className="cover-company">
        <img src={returnFullURL(coverUrl, 'cover')} alt="banner" />
      </div>

      <div
        style={{
          backgroundImage: `url(${fondo_intro_jhimbo})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="head-data-company">
          <div className="profile-company">
            <div className="logo-company shadow-company">
              <img src={returnFullURL(profileUrl, 'profile')} alt={"logo empresa " + companyName} />
            </div>

            <button className="follow-button-company" onClick={handleClickFollow}>
              {isFollowed ? <CheckIcon /> : <AddIcon />}
            </button>
          </div>

          <div className="head-info">
            <div>
              <h2 className="font-h2">{companyName}</h2>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', border: '1px solid rgba(0,0,0,0.3)', borderRadius: '10px', padding: '10px' }}>
              <div className="section-actions">
                <div className="actions-company" onClick={handleLike} style={{ cursor: "pointer" }}>
                  {liked ? (
                    <StarIcon
                      style={{
                        color: "#FFC107",
                        fontSize: "20px",
                      }}
                    />
                  ) : (
                    <StarBorderIcon
                      style={{
                        color: "#FFC107",
                        fontSize: "20px",
                      }}
                    />
                  )}
                  <span style={{ fontSize: 'var(--font-size-p)' }}>Favorito</span>
                </div>

                <button className="default-buttons actions-company" disabled={infoCompany ? false : true} onClick={() => setModalShare(true)}>
                  <ReplyIcon
                    style={{
                      color: 'var(--theme-visit)',
                      fontSize: "20px",
                    }}
                  />
                  <span style={{ fontSize: 'var(--font-size-p)' }}>Compartir</span>
                </button>

                <div className="actions-company" style={{ position: 'relative' }} id="more-info">
                  <InfoIcon
                    style={{
                      color: 'var(--theme-visit)',
                      fontSize: "20px",
                    }}
                  />
                  <span className="text-size">Mas</span>

                  <div className="modal-info-company shadow-company">
                    {
                      info_company
                    }
                  </div>
                </div>
              </div>

              <div id='info-company-pc'>
                {
                  info_company
                }
              </div>
            </div>
          </div>
        </div>

        <div
          className="Intro-jhimbo"
        >
          <div className="presentacion">
            {/* ---------- TÍTULO (un solo h2) ---------- */}
            <div className="title-presentacion">
              <h2>{parseTextWithBlue(view1.title || "Empresa importadora Maquinarias Jhimbo")}</h2>
            </div>

            {/* ---------- PÁRRAFO ---------- */}
            <div className="text-presentacion">
              <p>
                {firstSpan && <span style={{ color: 'var(--theme-visit)' }}>{firstSpan}</span>} {restOfText}
              </p>
            </div>

            {/* ---------- SLOGAN ---------- */}
            <div className="slogan">
              <div className="subtitle-slogan">
                <span>{view1.message_text || "En Jhimbo tenemos la mejor:"}</span>
              </div>
              <div className="calidad-badge" style={{ background: 'var(--theme-visit)' }}>
                <div className="calidad-icon-wrap">
                  <VerifiedIcon className="check-icon" />
                </div>
                <span>{view1.highlight_text || "Calidad"}</span>
              </div>
            </div>
          </div>

          {/* ---------- IMÁGENES ---------- */}
          <div className="presentacion-images">
            <div className="hex-container">
              <div className="hex hex-city">
                <img src={jhimbo_intro_1} alt="Imagen ciudad" />
              </div>
              <div className="hex hex-woman">
                <img src={jhimbo_intro_2} alt="Imagen mujer" />
              </div>
              <div className="hex hex-plant">
                <img src={jhimbo_intro_3} alt="Imagen planta" />
              </div>
              <div className="hex hex-blue" style={{ background: 'var(--theme-visit)' }} />
            </div>
          </div>
        </div>
      </div>

      <ModalForAll stateModal={modalShare} setStateModal={setModalShare}>
        <div className="container-share">
          <div>
            <h3>Compartir Empresa</h3>
            <p>Invita a otros a conocer "{companyName}" compartiendo este enlace único. El código QR también puede ser escaneado desde dispositivos móviles.</p>
          </div>

          <div className="container-qr" >
            <div style={{ position: 'relative' }} ref={contenedorRef}>
              <QRCodeSVG
                value={link_share}
                size={300}
                includeMargin={false}
                fgColor={'url(#gradienteRojoAzul)'}
              />

              <LogoHosmingSVG color='rgb(255,0,0)' stroke={false} style_code={{
                width: '120px',
                height: '120px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                zIndex: '5',
                transform: 'translate(-50%,-50%)',
              }}
              />

              <LogoHosmingSVG color='#fff' stroke={true} style_code={{
                width: '120px',
                height: '120px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                zIndex: '2',
                transform: 'translate(-50%,-50%)',
              }}
              />
            </div >

            <button className="default-buttons" onClick={() => handleDownloadSVG()} style={{ backgroundColor: 'transparent' }}><DownloadIcon sx={{ fontSize: '40px', color: '#000' }} /></button>
          </div>

          <div style={{ width: '100%', display: 'flex', gap: '10px' }}>
            <input className="shadow-lvl6" type="text" value={link_share} style={{ width: '100%' }} readOnly />
            <button className="default-buttons" onClick={() => copyLinkShare()}>Copiar!</button>
          </div>
        </div>

      </ModalForAll>
    </>
  );
};

export default HomePresentacion;